import { Link, useNavigate } from "react-router-dom";
import { useActionState, useEffect } from "react";
import FormBody from "../../../../components/form-body";
import Label from "../../../../components/label";
import Input from "../../../../components/input";
import FormError from "../../../../components/form-error";
import Textarea from "../../../../components/textarea";
import Toggle from "../../../../components/toggle";
import { Button } from "../../../../components/button";
import toast from "react-hot-toast";
import { createGreetingMembership, State } from "../actions";

export default function GreetingMembershipCreateForm() {
  const navigate = useNavigate();
  const initialState: State = {
    message: null,
    success: false,
    errors: {},
    defaultValues: {
      name: "",
      description: "",
      price: undefined,
      duration: 0,
      eGreets: 0,
      active: true,
    },
  };

  const [state, formAction, isPending] = useActionState(
    createGreetingMembership,
    initialState
  );

  useEffect(() => {
    if (state.success && state.defaultValues.id) {
      navigate(`/admin/greeting-memberships`);
      toast.success("Greeting membership created successfully");
    }
  }, [state, navigate]);

  return (
    <form className="max-w-3xl space-y-6 py-8 text-left" action={formAction}>
      <FormBody>
        <div className="mb-4">
          <Label htmlFor="name">Name</Label>
          <Input
            id="name"
            name="name"
            type="text"
            placeholder="Enter membership name"
            aria-describedby="name-error"
            defaultValue={state.defaultValues.name ?? ""}
            required
          />
          <FormError id="name-error" message={state.errors?.name} />
        </div>

        <div className="mb-4">
          <Label htmlFor="description">Description</Label>
          <Textarea
            id="description"
            name="description"
            placeholder="Enter description"
            aria-describedby="description-error"
            defaultValue={state.defaultValues.description ?? ""}
          />
          <FormError id="description-error" message={state.errors?.description} />
        </div>

        <div className="mb-4 grid grid-cols-1 gap-4 md:grid-cols-3">
          <div>
            <Label htmlFor="price">Price (Cloods)</Label>
            <Input
              id="price"
              name="price"
              type="number"
              required
              min={1}
              placeholder="Enter price"
              aria-describedby="price-error"
              defaultValue={state.defaultValues.price ?? ""}
            />
            <FormError id="price-error" message={state.errors?.price} />
          </div>
          <div>
            <Label htmlFor="duration">Duration</Label>
            <Input
              id="duration"
              name="duration"
              type="number"
              min={0}
              placeholder="Enter duration"
              aria-describedby="duration-error"
              defaultValue={state.defaultValues.duration ?? 0}
            />
            <FormError id="duration-error" message={state.errors?.duration} />
          </div>
          <div>
            <Label htmlFor="eGreets">EGreets</Label>
            <Input
              id="eGreets"
              name="eGreets"
              type="number"
              min={0}
              placeholder="Enter eGreets"
              aria-describedby="eGreets-error"
              defaultValue={state.defaultValues.eGreets ?? 0}
            />
            <FormError id="eGreets-error" message={state.errors?.eGreets} />
          </div>
        </div>

        <div className="mb-4">
          <Label htmlFor="active">Active</Label>
          <Toggle
            id="active"
            name="active"
            aria-describedby="active-error"
            checked={state.defaultValues.active ?? true}
          />
          <FormError id="active-error" message={state.errors?.active} />
        </div>
        <div className="mb-4 flex flex-col gap-2">
        <small className="text-gray-500">
          0 Duration means unlimited duration.
        </small>
        <small className="text-gray-500">
          0 eGreets means unlimited eGreets.
        </small>
        </div>
      </FormBody>

      <div className="mt-6 flex justify-end gap-4">
        <Link to="/admin/greeting-memberships">
          <Button type="reset" disabled={isPending}>
            Cancel
          </Button>
        </Link>
        <Button
          type="submit"
          disabled={isPending}
          loading={isPending}
          className="min-w-[90px]"
        >
          Save Changes
        </Button>
      </div>
    </form>
  );
}
